<template>
  <div id="layout-base-mobile" class="user-select-none">
    <div id="mobile-main">
      <main-canvas>
        <template slot="main-canvas">
          <slot name="main-canvas"/>
        </template>
      </main-canvas>
    </div>
    <div id="mobile-secondary-navbar">
      <mobile-secondary-navbar>
        <template slot="mobile-secondary-navbar">
          <slot name="mobile-secondary-navbar"/>
        </template>
      </mobile-secondary-navbar>  
    </div>
    <div id="mobile-navbar-container">
      <mobile-navbar>
        <template slot="mobile-navbar">
          <slot name="mobile-navbar"/>
        </template>
      </mobile-navbar>
    </div>
  </div>
</template>
<script>
import store from './../mixins/store.mixin'
import Topbar from "./components/Topbar.vue";
import SidebarRight from "./components/SidebarRight.vue";
import SidebarLeft from "./components/SidebarLeft.vue";
import MainCanvas from "./components/MainCanvas.vue";
import MobileNavbar from "./components/MobileNavbar.vue";
import MobileSecondaryNavbar from './components/MobileSecondaryNavbar.vue';

export default {
  name: "MobileLayout",
  props: {},
  components: {
    MobileNavbar,
    Topbar,
    SidebarRight,
    MainCanvas,
    SidebarLeft,
    MobileSecondaryNavbar
  },
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#layout-base-mobile {
  height: 100%;
  background: yellow;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

#mobile-main {
  display: flex;
  flex: 1 1 auto;
  border-top: 1px solid #595959;
  overflow: auto;
}

#mobile-navbar-container {
  display: flex;
  height: 75px;
  min-height: 75px;
  border-top: 1px solid #595959;
  background: #1E1E1E;
  width: 100%;
}
</style>
